import { render, staticRenderFns } from "./FormP5.vue?vue&type=template&id=6bcb9de1"
import script from "./FormP5.vue?vue&type=script&lang=ts"
export * from "./FormP5.vue?vue&type=script&lang=ts"
import style0 from "./FormP5.vue?vue&type=style&index=0&id=6bcb9de1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports